import CrudTable from '../../components/CrudTable';
import { db } from '../../lib/supabase';
import { formatVND, shortId } from '../../lib/format';

const PAY_STATUS = [
  { value: 'pending', label: 'Chờ thanh toán' },
  { value: 'paid', label: 'Đã thanh toán' },
  { value: 'refunded', label: 'Đã hoàn tiền' },
];
const ORDER_STATUS = [
  { value: 'pending', label: 'Mới' },
  { value: 'confirmed', label: 'Đã xác nhận' },
  { value: 'delivering', label: 'Đang giao' },
  { value: 'delivered', label: 'Đã giao' },
  { value: 'cancelled', label: 'Đã huỷ' },
];

export default function OrdersAdmin() {
  return (
    <CrudTable
      title="🧾 Đơn hàng (ship khách sạn)"
      table="orders"
      canAdd={false}
      columns={[
        { key: 'id', label: 'Mã', inForm: false, render: (r) => <code>{shortId(r.id)}</code> },
        { key: 'created_at', label: 'Lúc', type: 'datetime', inForm: false },
        { key: 'customer_name', label: 'Khách', type: 'text' },
        { key: 'customer_phone', label: 'SĐT', type: 'text' },
        { key: 'hotel_name', label: 'Khách sạn', type: 'text', render: (r) => r.hotel_name ? `${r.hotel_name}${r.room_number ? ` (P.${r.room_number})` : ''}` : (r.delivery_address || '—') },
        { key: 'room_number', label: 'Phòng', type: 'text', inTable: false },
        { key: 'delivery_address', label: 'Địa chỉ khác', type: 'text', inTable: false },
        { key: 'delivery_time', label: 'Giờ nhận', type: 'text', inTable: false },
        { key: 'items', label: 'Món', inForm: false, render: (r) => (
            <details>
              <summary>{Array.isArray(r.items) ? r.items.length : 0} món</summary>
              <ul style={{ margin: 4, paddingLeft: 16 }}>
                {(Array.isArray(r.items) ? r.items : []).map((it, i) => (
                  <li key={i}>{it.name} × {it.qty} — {formatVND(it.price * it.qty)}</li>
                ))}
              </ul>
            </details>
          ) },
        { key: 'total', label: 'Tổng', type: 'number', render: (r) => <strong>{formatVND(r.total)}</strong> },
        { key: 'payment_method', label: 'PTTT', type: 'select', options: [
            { value: 'cod', label: 'COD' }, { value: 'bank_transfer', label: 'Chuyển khoản' }] },
        { key: 'payment_status', label: 'Thanh toán', type: 'select', options: PAY_STATUS },
        { key: 'status', label: 'Trạng thái', type: 'select', options: ORDER_STATUS },
        { key: 'admin_note', label: 'Ghi chú', type: 'textarea', inTable: false },
      ]}
      rowActions={(row, reload) => (
        <>
          {row.payment_status === 'pending' && (
            <button
              className="btn btn-primary btn-sm"
              title="Xác nhận đã nhận tiền"
              onClick={async () => { await db.update('orders', row.id, { payment_status: 'paid' }); reload(); }}
            >💰</button>
          )}
          {row.status !== 'delivered' && row.status !== 'cancelled' && (
            <button
              className="btn btn-secondary btn-sm"
              title="Đánh dấu đã giao"
              onClick={async () => { await db.update('orders', row.id, { status: 'delivered' }); reload(); }}
            >✅</button>
          )}
        </>
      )}
      emptyText="Chưa có đơn hàng nào."
    />
  );
}
